/**
 * AuctionListHeading - Section heading with sort dropdown for auction listings
 *
 * Displays an icon, title, and subtitle along with a "Sort By" dropdown that
 * toggles visibility of sort options. Calls the sav callback with the selected sort option.
 *
 * @param {Object} props
 * @param {string} props.img - Icon image URL (displayed in header)
 * @param {string} props.text - Subtitle/description text (e.g., "Live Auctions")
 * @param {string} props.title - Main heading title (e.g., "Browse Auctions")
 * @param {function} props.sav - Callback invoked with sort selection:
 *        "Ending Soonest", "Highest Bids", "Highest Reserve", or "Newest Listings"
 * @returns {React.ReactElement} Rendered heading with sort dropdown
 */
const AuctionListHeading = ({img, text, title, sav}) => {

    const expandSel = () => {
        let opts = document.getElementById('opts');
        opts.style.visibility === "visible" ? opts.style.visibility = "hidden" : opts.style.visibility = "visible"
        //alert("click")
    }

    const savs = (val) => {
      //  alert(val);
        sav(val);
    }

    return (
        <>
            <div className="d-flex text-green" style={{justifyContent: "space-between"}}>
                <div className="container-fluid section-heading text-green d-flex mt-20 mb-15" style={{order: "1"}}>
                    <div className="img-div text-green mr-10"><img style={{height: "3em"}} src={img} alt=""/></div>
                    <div className="d-flex text-green flex-column h-100">
                        <div className="row text-green">
                            <div className="mb-1 pt-2 text-bold text-green col-xs-6" style={{whiteSpace: "pre", position: "relative"}}>{text}</div>
                        </div>
                        <h5 className="font-weight-bolder text-primary" style={{whiteSpace: "pre", position: "relative"}}>{title}</h5>
                    </div>
                </div>

                <div className="section-heading mb-16 mt-20 pt-2 text-bold text-green col-xs-6 mr-15"
                     style={{
                         position: "relative",
                         cursor: "pointer",
                         marginRight: "20px",
                         whiteSpace: "pre",
                         width: "fit-content",
                         order: "2"
                     }}
                     id="selMode"
                     onClick={() => expandSel()}>
                    <h5 className="text-green">Sort By</h5>
                    <div id="opts" style={{
                        borderRadius: "10px",
                        padding: "10px",
                        right: "0px",
                        border: "2px solid #888",
                        background: "#000000CC",
                        lineHeight: "2em",
                        visibility: "hidden",
                        position: "absolute",
                        zIndex: "500"
                    }}>
                        <span onClick={() => savs("Ending Soonest")}>Ending Soonest</span><br/>
                        <span onClick={() => savs("Highest Bids")}>Highest Bid</span><br/>
                        <span onClick={() => savs("Highest Reserve")}>Highest Reserve</span><br/>
                        <span onClick={() => savs("Newly Listed")}>Newest Listings</span>
                    </div>
                </div>

            </div>
            {/*</div>*/}


            {/*</div>*/}
        </>
    );
}

export default AuctionListHeading;
